import { useEffect, useState } from "react";

export function useTimedVisibility(
    value: number,
    maxValue: number,
    durationMs: number
) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (value < maxValue) {
            setVisible(false);
            return;
        }

        setVisible(true);
        const timer = setTimeout(() => setVisible(false), durationMs);

        return () => clearTimeout(timer);
    }, [value, maxValue, durationMs]);

    return visible;
}
